(() => {
  const normalize = (value = '') => value.trim().toLowerCase().replace(/\s+/g, ' ');

  async function findProductUrl(title) {
    const base = window.Theme?.routes?.predictive_search_url || '/search/suggest';
    const endpoint = base.endsWith('.json') ? base : `${base}.json`;
    const params = new URLSearchParams({
      q: title,
      'resources[type]': 'product',
      'resources[limit]': '6',
      'resources[options][unavailable_products]': 'last'
    });
    const response = await fetch(`${endpoint}?${params.toString()}`, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Product lookup failed');
    const data = await response.json();
    const products = data?.resources?.results?.products || [];
    const exact = products.find(product => normalize(product.title) === normalize(title));
    return (exact || products[0])?.url || null;
  }

  async function addSimpleVariant(button, variantId) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{
          id: Number(variantId),
          quantity: 1,
          properties: {
            'Café fulfillment': 'Free Pickup — 4497 N University Drive, Lauderhill, FL 33351'
          }
        }]
      })
    });
    if (!response.ok) throw new Error('Add failed');
  }

  document.addEventListener('click', async event => {
    const button = event.target.closest('.renew-home [data-home-add]');
    if (!button || button.disabled) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const variantId = button.dataset.variantId;
    const title = button.dataset.productTitle || '';
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Checking…';

    try {
      const variantResponse = await fetch(`/variants/${variantId}.js`, {
        headers: { Accept: 'application/json' }
      });
      if (!variantResponse.ok) throw new Error('Variant lookup failed');
      const variant = await variantResponse.json();
      const hasChoice = variant?.title && normalize(variant.title) !== 'default title';

      if (hasChoice) {
        button.textContent = 'Choose Options…';
        const productUrl = await findProductUrl(title);
        if (productUrl) {
          window.location.assign(productUrl);
          return;
        }
        window.location.assign(`/search?q=${encodeURIComponent(title)}`);
        return;
      }

      button.textContent = 'Adding…';
      await addSimpleVariant(button, variantId);
      button.textContent = 'Added ✓';
      window.setTimeout(() => {
        button.disabled = false;
        button.textContent = original;
      }, 1200);
    } catch (error) {
      button.disabled = false;
      button.textContent = 'View Options';
      try {
        const productUrl = await findProductUrl(title);
        if (productUrl) button.addEventListener('click', () => window.location.assign(productUrl), { once: true });
      } catch (_) {}
      window.setTimeout(() => {
        if (!button.disabled) button.textContent = original;
      }, 1800);
    }
  }, true);
})();
